import { Duration } from "date-fns";
import addDate from "date-fns/add";
import dateFnsformat from "date-fns/format";
import getDate from "date-fns/getDate";
import getMonth from "date-fns/getMonth";
import getYear from "date-fns/getYear";
import isAfterDate from "date-fns/isAfter";
import isDateFns from "date-fns/isDate";
import { nlBE } from "date-fns/locale";
import parseDateFns from "date-fns/parse";
import parseISODate from "date-fns/parseISO";
import sub from "date-fns/sub";
import { isDefined } from "./helpers";

type FormatOptions = {
    locale?: Locale;
    weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
    firstWeekContainsDate?: number;
    useAdditionalWeekYearTokens?: boolean;
    useAdditionalDayOfYearTokens?: boolean;
};

const formatISO = (
    value?: string | null,
    format: string = "dd/MM/yyyy",
    options: FormatOptions = {},
): string => {
    if (!value) {
        return "";
    }

    // @ts-ignore - option not available in typings?
    const parsedValue = parseISODate(value, { locale: nlBE });
    return dateFnsformat(parsedValue, format, { locale: nlBE, ...options });
};

const formatDate = (
    value?: Date,
    format: string = "dd/MM/yyyy",
    options: FormatOptions = {},
): string => {
    if (!value) {
        return "";
    }

    return dateFnsformat(value, format, { locale: nlBE, ...options });
};

const parseISO = (value?: string | null): Date => {
    if (!value) {
        return new Date();
    }
    // @ts-ignore
    const parsedDate = parseISODate(value, { locale: nlBE });

    if (!isDateFns(parsedDate)) {
        throw new Error("Invalid date");
    }

    return parsedDate;
};

const safeParseISO = (value: string | undefined | null): Date | undefined => {
    if (!isDefined(value)) return undefined;

    const date = new Date(Date.parse(value));

    return isNaN(date.getTime()) ? undefined : date;
}

const parseDate = (value: string, providedFormat: string): Date => {
    if (!value) {
        return new Date();
    }
    const parsedDate = parseDateFns(value, providedFormat, new Date(), {
        locale: nlBE,
    });
    if (!isDateFns(parsedDate)) {
        throw new Error("Invalid date");
    }

    return parsedDate;
};

const isAfter = (startDate: Date, endDate: Date): boolean => {
    return isAfterDate(startDate, endDate);
};

const add = (date: Date, duration: Duration): Date => {
    return addDate(date, duration);
};

const substract = (date: Date, duration: Duration): Date => {
    return sub(date, duration);
};

const isDate = (date: any): boolean => {
    return isDateFns(date);
};

type SplittedDate = {
    day?: number;
    month?: number;
    year?: number;
};

const splitDate = (date: Date): SplittedDate => {
    return {
        day: getDate(date),
        month: getMonth(date) + 1,
        year: getYear(date),
    };
};

export {
    formatISO,
    formatDate,
    parseISO,
    safeParseISO,
    parseDate,
    isAfter,
    add,
    substract,
    isDate,
    splitDate,
};
